/**
 * PipelinePanel — shared card/panel wrapper for the pipeline board.
 *
 * Used by both PipelineColumn (outer column container) and PipelineCard
 * (individual entity cards) to ensure consistent border, background,
 * border-radius, and shadow styling across the board.
 */

import type { ReactNode } from 'react';

import { cx } from '@/utils/cx';

/** Base layout classes shared by all pipeline panels (columns and cards). */
export const PIPELINE_PANEL_CLASSES =
  'rounded-lg border border-border-secondary shadow-sm';

interface PipelinePanelProps {
  children: ReactNode;
  className?: string;
}

export function PipelinePanel({ children, className }: PipelinePanelProps) {
  return (
    <div className={cx(PIPELINE_PANEL_CLASSES, className)}>{children}</div>
  );
}
